import { render, staticRenderFns } from "./NumeroArreteCTM.vue?vue&type=template&id=6d550ba6"
import script from "./NumeroArreteCTM.vue?vue&type=script&lang=js"
export * from "./NumeroArreteCTM.vue?vue&type=script&lang=js"
import style0 from "./NumeroArreteCTM.vue?vue&type=style&index=0&id=6d550ba6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports